$(document).ready(function () {

    //warehouse////////////////////////////////////////////////////////////////////////////////
    var coll = document.getElementsByClassName("collapsible");
    var i;

    for (i = 0; i < coll.length; i++) {
        coll[i].addEventListener("click", function () {
            this.classList.toggle("active");
            var content = this.nextElementSibling;
            if (content.style.display === "block") {
                content.style.display = "none";
            } else {
                content.style.display = "block";
            }
        });
    }

    function trans(translation) {
        var language = document.documentElement.lang;

        return _.get(window.i18n, language + "." + translation);
    }

    $(function () {
        var start = moment().subtract(29, 'days');
        var end = moment();

        function cb(start, end) {
            $('#reportrange span').html(start.format('YYYY-MM-D') + '_' + end.format('YYYY-MM-DD'));
            $("#from").val(start.format('YYYY-MM-D'));
            $("#to").val(end.format('YYYY-MM-DD'));
        }

        $('#reportrange').daterangepicker({
            startDate: start,
            endDate: end,
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            }
        }, cb);

        cb(start, end);


    });
    $(".shop-edit-button").on("click", function (event) {
        //event.target.attributes[0].value manage-config-shop-change-btn
        let config_id = event.target.attributes[0].value;
        $.ajax({
            url: '/manage/api/get/api/' + config_id,
            type: "get",
            dataType: "json",
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                $("#shop").val(data["shop"]);
                $("#url").val(data["url"]);
                $("#version").val(data["version"]);
                $("#clientId").val(data["clientId"]);
                $("#clientSecret").val(data["clientSecret"]);
                $("#password").val(data["password"]);
                $("#easybill_bearer").val(data["easybill_bearer"]);
                $("#easybill_id").val(data["easybill_id"]);
                $("#manage-config-shop-hidden-field").val(data["id"]);

            },
            error: function () {

            }
        });
    });
    $("#ct_config_btn").on("click", function (event) {
        if (confirm("Create Shop-Config?")) {
            $.ajax({
                url: '/manage/api/create',
                type: "post",
                dataType: "json",
                data: {
                    abteilung: $("#ct_abteilung option:selected").val(),
                    shop: $("#ct_shop").val(),
                    url: $("#ct_url").val(),
                    version: $("#ct_version").val(),
                    clientId: $("#ct_clientid").val(),
                    clientSecret: $("#ct_clientsecret").val(),
                    password: $("#ct_password").val(),
                    easybill_bearer: $("#ct_easybill_bearer").val(),
                    easybill_id: $("#ct_easybill_id").val(),
                },
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    $("#alert").append("<strong>Success!</strong> Changes saved successfully.");
                    $("#alert").show().delay(4).fadeOut();
                    location.reload();
                },
                error: function () {
                }
            });
        } else {
        }

    });
    $("#manage-create-bearer-Token-btn").on("click", function () {
        function Generator() {
        }

        Generator.prototype.rand = Math.floor(Math.random() * 26) + Date.now();

        Generator.prototype.getId = function () {
            return (this.rand * this.rand) * 2 + Date.now();
        };
        var idGen = new Generator();
        var token = $("#clientSecret").val(btoa(idGen.getId()));
    });

    $("#manage-config-shop-change-btn").on("click", function (event) {
        //event.target.attributes[0].value
        if (confirm("Save Shop-Config?")) {
            if ($("#manage-config-shop-hidden-field").val() != '') {
                $.ajax({
                    url: '/manage/api/update/' + $("#manage-config-shop-hidden-field").val(),
                    type: "post",
                    dataType: "json",
                    data: {
                        shop: $("#shop").val(),
                        url: $("#url").val(),
                        version: $("#version").val(),
                        clientId: $("#clientId").val(),
                        clientSecret: $("#clientSecret").val(),
                        password: $("#password").val(),
                        easybill_bearer: $("#easybill_bearer").val(),
                        easybill_id: $("#easybill_id").val(),
                        user_id: $("#user_id").val(),
                    },
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {
                        $("#alert").append("<strong>Success!</strong> Changes saved successfully.");
                        $("#alert").show().delay(4).fadeOut();
                    },
                    error: function () {
                    }
                });
            }
        } else {
        }

    });


    if ($('#loading').val() === "1") {
        $('.loading-screen').addClass('active');
        let CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
        let ajaxUrl = $('#url').val();
        let json = $('#jsonData').val();

        let interval = setInterval(function () {
            $.ajax({
                url: ajaxUrl,
                type: 'post',
                dataType: 'json',
                async: true,
                data: {
                    _token: CSRF_TOKEN,
                    data: json
                },
                success: function (data) {
                    if (data.succeeded === 1) {
                        console.log(data);

                        $('.loading-screen').removeClass('active');
                        clearInterval(interval);
                    }
                },
                error: function (data) {
                    $('.loading-screen').removeClass('active');

                }
            });
        }, 10000);
    }

    $("#order_detail_status").on("click", function () {
        if (confirm("Change Order status to processing?")) {
            $.ajax({
                url: '/order/detail/status/update/' + $("#order_detail_ordernumber").val() + '/4',
                type: "post",
                dataType: "json",

                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    location.reload();
                },
                error: function () {

                }
            });
        } else {

        }

    });

    $("#order_detail_close").on("click", function () {
        if (confirm("Change Order status to closed?")) {
            $.ajax({
                url: '/order/detail/status/update/' + $("#order_detail_ordernumber").val() + '/8',
                type: "post",
                dataType: "json",
                data: {
                    stockChange: true
                },

                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    location.reload();
                },
                error: function () {

                }
            });
        } else {

        }
    });

    $("#order_detail_complete").on("click", function () {
        if (confirm("Change Order status to complete?")) {
            $.ajax({
                url: '/order/detail/status/complete/' + $("#order_detail_ordernumber").val(),
                type: "post",
                dataType: "json",

                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    location.reload();
                },
                error: function () {

                }
            });
        } else {

        }
    });
    $("#order_detail_retoure").on("click", function () {
        if (confirm("Add retoure?")) {
            var win = window.open('retoure/' + $("#order_detail_ordernumber").val(), '_blank');
            if (win) {
                //Browser has allowed it to be opened
                win.focus();
            } else {
                //Browser has blocked it
                alert('Please allow popups for this website');
            }
        } else {

        }
    });

    $("#order_detail_allow_reprint").on("click", function () {
        if (confirm("Allow invoice reprint?")) {
            $.ajax({
                url: '/order/detail/invoice/reprint' + $("#order_detail_ordernumber").val(),
                type: "post",
                dataType: "json",

                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    location.reload();
                },
                error: function () {

                }
            });
        } else {

        }

    });

    $("#order_detail_save").on("click", function () {
        if (confirm("Change Order Ship-Informations?")) {
            $.ajax({
                url: '/order/detail/address/update/' + $("#order_detail_ordernumber").val(),
                type: "post",
                dataType: "json",
                data: JSON.stringify({
                    shipTo: {
                        street: $("#street").val(),
                        housenumber: $("#housenumber").val(),
                        countrycode: $("#countrycode").val(),
                        plz: $("#plz").val(),
                        city: $("#city").val(),
                        state: $("#state").val(),
                        firstname: $("#firstname").val(),
                        lastname: $("#lastname").val(),
                        company: $("#company").val(),
                        additional_lines: $("#additional").val(),
                        email: $("#email").val(),
                        phone: $("#phone").val(),
                    },
                    shipFrom: {
                        street: $("#shipFrom_street").val(),
                        housenumber: $("#shipFrom_housenumber").val(),
                        countrycode: $("#shipFrom_countrycode").val(),
                        plz: $("#shipFrom_plz").val(),
                        city: $("#shipFrom_city").val(),
                        state: $("#shipFrom_state").val(),
                        firstname: $("#shipFrom_firstname").val(),
                        lastname: $("#shipFrom_lastname").val(),
                        company: $("#shipFrom_company").val(),
                        additional_lines: $("#shipFrom_additional").val(),
                        email: $("#shipFrom_email").val(),
                        phone: $("#shipFrom_phone").val(),
                    },
                    scheduled_shipment_date: $("#scheduled_shipment_date").val(),
                    status: $("#status").val()
                }),
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    location.reload();
                },
                error: function () {

                }
            });
        } else {

        }
    });

    $("#order_detail_delete_shipment").on("click", function () {
        if (confirm("Delete Order Ship-Informations?")) {
            $.ajax({
                url: '/order/detail/shipment/delete/' + $("#order_detail_ordernumber").val(),
                type: "post",
                dataType: "json",
                data: {},
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {

                    location.reload();
                },
                error: function () {

                }
            });
        } else {

        }
    });
    $("#order_detail_prio").on("click", function () {
        if (confirm("Prioritize order?")) {
            $.ajax({
                url: '/order/detail/prio/' + $("#order_detail_ordernumber").val(),
                type: "post",
                dataType: "json",
                data: {},
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {

                    location.reload();
                },
                error: function () {

                }
            });
        } else {

        }
    });
    $("#order_detail_webhook").on("click", function () {
        if (confirm("Fire Webhook?")) {
            $.ajax({
                url: '/order/detail/webhook/fire/' + $("#order_detail_ordernumber").val(),
                type: "post",
                dataType: "json",
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    console.log(data);
                    location.reload();
                },
                error: function () {

                }
            });
        } else {

        }
    });


    $("#manage-mandant-btn-save").hide();
    $(".mandant-edit").on("click", function (event) {

        $.ajax({
            url: '/manage/mandant/edit/' + event.target.attributes[0].value,
            type: "post",
            dataType: "json",
            data: {id: event.target.attributes[0].value},
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {

                $("#mandant").val("");
                $("#street").val("");
                $("#housenumber").val("");
                $("#countrycode").val("");
                $("#plz").val("");
                $("#city").val("");
                $("#state").val("");
                $("#firstname").val("");
                $("#lastname").val("");
                $.each(data, function (key, value) {
                    if (key === "name") {
                        $("#mandant").val(value);

                    }
                    if (key === "id") {
                        $("#manage-mandant-hidden").val(value);
                    }
                    if (key === "address") {
                        $.each(value, function (key2, value2) {

                            switch (key2) {
                                case "street":
                                    $("#street").val(value2);
                                    break;
                                case "housenumber":
                                    $("#housenumber").val(value2);
                                    break;
                                case "country_code":
                                    $("#countrycode").val(value2);
                                    break;
                                case "plz":
                                    $("#plz").val(value2);
                                    break;
                                case "city":
                                    $("#city").val(value2);
                                    break;
                                case "state":
                                    $("#state").val(value2);
                                    break;
                                case "first_name":
                                    $("#firstname").val(value2);
                                    break;
                                case "last_name":
                                    $("#lastname").val(value2);
                                    break;
                                default:

                                    break;
                            }
                        });
                    }
                });

                $("#manage-mandant-btn-save").show();


            },
            error: function () {

            }
        });

    });
    $(".mandant-delete").on("click", function (event) {
        if (confirm('Are you sure you want to delete this Mandant?')) {
            $.ajax({
                url: '/manage/mandant/delete/' + event.target.attributes[0].value,
                type: "post",
                dataType: "json",
                data: {id: event.target.attributes[0].value},
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    location.reload();
                },
                error: function () {

                }
            });
        } else {
            // Do nothing!hjhjhjjh
        }
    });

    $("#manage-mandant-btn-save").on("click", function (event) {
        if (confirm('Are you sure you want to save this Mandant?')) {
            var obj = {};
            obj["name"] = $("#mandant").val();
            obj["street"] = $("#street").val();
            obj["housenumber"] = $("#housenumber").val();
            obj["country_code"] = $("#countrycode").val();
            obj["plz"] = $("#plz").val();
            obj["city"] = $("#city").val();
            obj["state"] = $("#state").val();
            obj["first_name"] = $("#firstname").val();
            obj["last_name"] = $("#lastname").val();


            $.ajax({
                url: '/manage/mandant/update/' + $("#manage-mandant-hidden").val(),
                type: "post",
                dataType: "json",
                data: {data: obj},
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    $("#manage-mandant-btn-save").hide();
                    location.reload();
                    $("#manage-mandant-btn-save").hide();
                },
                error: function () {

                }
            });

        } else {
            $("#mandant").val("");
            $("#street").val("");
            $("#housenumber").val("");
            $("#countrycode").val("");
            $("#plz").val("");
            $("#city").val("");
            $("#state").val("");
            $("#firstname").val("");
            $("#lastname").val("");
            $("#manage-mandant-btn-save").hide();
        }
    });


    $("#abteilung-save-btn").hide();
    $(".abteilung-edit").on("click", function (event) {

        $.ajax({
            url: '/manage/abteilung/edit/' + event.target.attributes[0].value,
            type: "post",
            dataType: "json",
            data: {id: event.target.attributes[0].value},
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {

                $("#abteilung").val("");
                $("#customer_number").val("");
                $("#pricegroup").val("");
                $("#mandant").val("");
                $.each(data, function (key, value) {
                    if (key === "name") {
                        $("#abteilung").val(value);
                    }
                    if (key === "id") {
                        $("#manage-abteilung-hidden").val(value);
                    }
                    if (key === "customer_number") {
                        $("#customer_number").val(value);
                    }
                    if (key === "pricegroup") {
                        var pricegroup = $("select[name='pricegroup']")[0];

                        $.each(pricegroup.options, function (index, option) {
                            if (option.value === value) {
                                pricegroup.selectedIndex = index;
                            }
                        });
                    }
                    if (key === "mandant") {
                        var mandant = $("select[name='mandant']")[0];

                        $.each(mandant.options, function (index, option) {
                            if (option.value === value) {
                                mandant.selectedIndex = index;
                            }
                        });
                    }
                });

                $("#abteilung-save-btn").show();


            },
            error: function () {

            }
        });

    });
    $(".abteilung-delete").on("click", function (event) {
        if (confirm(trans('page.management.abteilung.delete.message'))) {
            $.ajax({
                url: '/manage/abteilung/delete/' + event.target.attributes[0].value,
                type: "post",
                dataType: "json",
                data: {id: event.target.attributes[0].value},
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    location.reload();
                },
                error: function () {

                }
            });
        } else {
            // Do nothing!hjhjhjjh
        }
    });
    $("#abteilung-save-btn").on("click", function (event) {
        if (confirm(trans('page.management.abteilung.edit.update'))) {
            //var obj = {};
            //obj["name"] = $("#abteilung").val();
            //obj["mandant"] = $("#mandant").option.val();
            //obj["pricegroup"] = $("#pricegroup").option.val();
            //obj["customer_number"] = $("#customer_number").val();

            $.ajax({
                url: '/manage/abteilung/update/' + $("#manage-abteilung-hidden").val(),
                type: "post",
                dataType: "json",
                data: {
                    name: $("#abteilung").val(),
                    mandant: $("#mandant option:selected").val(),
                    pricegroup: $("#pricegroup option:selected").val(),
                    customer_number: $("#customer_number").val(),
                },
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    //$("#abteilung-save-btn").hide();
                    location.reload();
                    $("#abteilung-save-btn").hide();
                },
                error: function () {

                }
            });

        }
    });


    $("#pricegroup-save-btn").hide();
    $(".pricegroup-edit").on("click", function (event) {

        $.ajax({
            url: '/manage/pricegroup/edit/' + event.target.attributes[0].value,
            type: "post",
            dataType: "json",
            data: {id: event.target.attributes[0].value},
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {

                $("#pricegroup_name").val("");
                $("#charge").val("");
                $("#percent").val("");
                $.each(data, function (key, value) {
                    if (key === "name") {
                        $("#pricegroup_name").val(value);
                    }
                    if (key === "id") {
                        $("#manage-pricegroup-hidden").val(value);
                    }
                    if (key === "charge") {
                        $("#charge").val(value);
                    }
                    if (key === "percent") {
                        $("#percent").val(value);
                    }
                });

                $("#pricegroup-save-btn").show();


            },
            error: function () {

            }
        });

    });
    $(".pricegroup-delete").on("click", function (event) {
        if (confirm(trans('page.management.pricegroup.delete.message'))) {
            $.ajax({
                url: '/manage/pricegroup/delete/' + event.target.attributes[0].value,
                type: "post",
                dataType: "json",
                data: {id: event.target.attributes[0].value},
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    location.reload();
                },
                error: function () {

                }
            });
        } else {
            // Do nothing!hjhjhjjh
        }
    });
    $("#pricegroup-save-btn").on("click", function (event) {
        if (confirm(trans('page.management.pricegroup.edit.update'))) {
            var obj = {};
            obj["pricegroup_name"] = $("#pricegroup_name").val();
            obj["charge"] = $("#charge").val();
            obj["percent"] = $("#percent").val();

            $.ajax({
                url: '/manage/pricegroup/update/' + $("#manage-pricegroup-hidden").val(),
                type: "post",
                dataType: "json",
                data: {
                    "pricegroup_name": $("#pricegroup_name").val(),
                    "charge": $("#charge").val(),
                    "percent": $("#percent").val(),
                },
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    //$("#abteilung-save-btn").hide();
                    location.reload();
                    $("#pricegroup-save-btn").hide();
                },
                error: function () {

                }
            });

        }
    });


    $(".select-role").focusout(function () {
        var selectedValues = $(this).find('option:selected').map(function () {
            return this.value;
        }).get();

        $.ajax({
            url: '/user/role/change/' + this.id,
            type: "post",
            dataType: "json",
            data: {roles: selectedValues},
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {

                location.reload();
            },
            error: function () {

            }
        });
    });
    $(".select-mandant").focusout(function () {
        var selectedValues = $(this).find('option:selected').map(function () {
            return this.value;
        }).get();
        $.ajax({
            url: '/user/mandant/change/' + this.id,
            type: "post",
            dataType: "json",
            data: {mandant: selectedValues},
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                location.reload();
            },
            error: function () {
            }
        });
    });
    $(".select-abteilung").focusout(function () {
        var selectedValues = $(this).find('option:selected').map(function () {
            return this.value;
        }).get();
        $.ajax({
            url: '/user/abteilung/change/' + this.id,
            type: "post",
            dataType: "json",
            data: {abteilung: selectedValues},
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                location.reload();
            },
            error: function () {
            }
        });

    });
    $(".select-shop").focusout(function () {
        var selectedValues = $(this).find('option:selected').map(function () {
            return this.value;
        }).get();
        $.ajax({
            url: '/user/shop/change/' + this.id,
            type: "post",
            dataType: "json",
            data: {roles: selectedValues},
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                location.reload();
            },
            error: function () {
            }
        });
    });

    function call() {
        if (event.target.className === "")

            $.ajax({
                url: '/user/role/change/',
                type: "post",
                dataType: "json",
                async: false,
                data: {roles: unselectedValues},
                success: function (data) {
                    location.reload();
                },
                error: function () {

                }


            });
    }

    $('#dropdown').hover(function () {
        $(this).AddClass('open');
    });
    $('.count').each(function () {
        $(this).prop('Counter', 0).animate({
            Counter: $(this).text()
        }, {
            duration: 2500,
            easing: 'swing',
            step: function (now) {
                $(this).text(Math.ceil(now));
            }
        });
    });
    $('ul.dropdown-menu [data-toggle=dropdown]').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        $(this).parent().siblings().removeClass('open');
        $(this).parent().toggleClass('open');
    });
    $(".import").on("click", function () {
        $(".exportsubmenu").css("visibility", "hidden");
        $(".importsubmenu").css("visibility", "visible");
        $(".storage-submenu").css("visibility", "hidden");
    });
    $(".export").on("click", function () {
        $(".importsubmenu").css("visibility", "hidden");
        $(".exportsubmenu").css("visibility", "visible");
        $(".storage-submenu").css("visibility", "hidden");
    });
    $(".storage").on("click", function () {
        $(".importsubmenu").css("visibility", "hidden");
        $(".exportsubmenu").css("visibility", "hidden");
        $(".storage-submenu").css("visibility", "visible");
    });

    $('#report_restock_btn').on('click', function () {
        let spinners = $('.number-input-spinner input[type="number"]');
        let request = [];

        spinners.each(function (key, spinner) {
            if( spinner.value != 0){
                let productId = spinner.parentElement.id.substr(8);

                request.push(new Object({
                    product_id: productId,
                    supplier_id: $('#supplier_' + productId).val(),
                    quantity: parseInt(spinner.value)
                }));
            }
        });

        console.log(request);

        $.ajax({
            url: '/article/report/rebook',
            type: "post",
            dataType: "json",
            async: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: {products: request},
            success: function (data) {
                location.reload();
            },
            error: function (data) {
                alert('something went wrong!');
            }
        });
    });
});


